// src/pages/GroupsList.js

import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../firebase';

const GroupsList = () => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const groupsCollection = collection(db, 'groups');
        const groupSnapshot = await getDocs(groupsCollection);
        const groupsData = groupSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setGroups(groupsData);
      } catch (error) {
        console.error('Error fetching groups:', error);
      }
    };
    fetchGroups();
  }, []);

  return (
    <div>
      <div className="container mx-auto mt-8 p-4 bg-white shadow-md rounded-lg">
        <h1 className="text-3xl font-bold text-primary mb-6">Groups List</h1>
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b text-left font-semibold text-neutral">Group Name</th>
              <th className="px-4 py-2 border-b text-left font-semibold text-neutral">Number of Members</th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <tr key={group.id} className="hover:bg-gray-100 transition-colors">
                <td className="px-4 py-2 border-b text-neutral">
                  <Link to={`/group/${group.id}`} className="text-indigo-600 hover:underline">
                    {group.name}
                  </Link>
                </td>
                <td className="px-4 py-2 border-b text-neutral">{group.users ? group.users.length : 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupsList;
